import { verifyRedirectedTenantName } from '@tools/api/api';
import { I18nStore } from '@tools/i18n/store';
import { injectTSDI } from '@tools/tsdi';
import { getQueryParams, isDev } from '@tools/utils/url';
import { FieldState, FormState } from 'formstate';
import { makeAutoObservable } from 'mobx';
import { component } from 'tsdi';

const getCookieValue = (name: string) =>
    // eslint-disable-next-line @typescript-eslint/prefer-regexp-exec
    document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`)?.pop() || '';

@component
export class LoginStore {
    public form = new FormState({
        returnedTenantName: new FieldState('')
            .validators((val) => {
                if (!val) {
                    const { translate } = injectTSDI(I18nStore);
                    return translate('commons.validation.required');
                }
                return false;
            })
            .disableAutoValidation()
    });

    constructor() {
        makeAutoObservable(this);
        void this.init();
    }

    private async init() {
        let returnedTenant;
        try {
            const tenantInfo = await verifyRedirectedTenantName();
            returnedTenant = tenantInfo.tenantName;
        } catch (error) {
            console.error('Error while verifying tenant name', error);
            returnedTenant = getCookieValue('_ml_rut');
        }
        if (returnedTenant) {
            this.form.$.returnedTenantName.reset(returnedTenant);
        }
    }

    public onSubmit = () => {
        const { returnedTenantName } = this.form.$;
        let target = getQueryParams('target');
        const sourcePlatform = getQueryParams('source_platform');
        if (target) {
            target = decodeURIComponent(target);
            // NOTE: "/#/path" or "#/path" or "/path" => "/#/path"
            target = target.replace(/^\//, '');
            target = target.replace(/^#\//, '');
            target = `/#/${target}`;
        } else {
            target = '';
        }
        const utmSourcePlatform = sourcePlatform
            ? `?utm_source_platform=${sourcePlatform}`
            : '';
        window.location.href = `https://${returnedTenantName.value}.web${
            isDev() ? '.dev' : ''
        }.magicline.com${utmSourcePlatform}${target}`;
    };
}
